import clsx from "clsx";
import { Check, Exclamation, LockFill } from "react-bootstrap-icons";
import styles from "./StepIndicator.module.scss";

interface Props {
  stepNumber: number;
  isLocked?: boolean;
  isWarning?: boolean;
  isSuccess?: boolean;
  isLoading?: boolean;
}

export default function StepIndicator({
  stepNumber,
  isLocked = false,
  isWarning = false,
  isSuccess = false,
  isLoading = false,
}: Props) {
  return (
    <div className={"d-flex flex-column align-items-center"}>
      <div
        className={clsx(
          `${styles.step} d-flex justify-content-center align-items-center`,
          isWarning && styles.warning,
          isSuccess && styles.check,
          isLoading && styles.loading,
          isLocked && styles.locked,
        )}
      >
        <div data-testid="step-indicator">
          {isLocked ? (
            <LockFill size={18} />
          ) : isWarning ? (
            <Exclamation size={42} />
          ) : isSuccess ? (
            <Check size={42} />
          ) : (
            stepNumber
          )}
        </div>
      </div>

      {stepNumber !== 3 && <div className={styles.stepLine} />}
    </div>
  );
}
